var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverdueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02944 4.02944 0 9 0H25C29.9706 0 34 4.02944 34 9V25C34 29.9706 29.9706 34 25 34H9C4.02944 34 0 29.9706 0 25V9Z",
    fill: "#FFF1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 17C23.75 20.7279 20.7279 23.75 17 23.75C13.2721 23.75 10.25 20.7279 10.25 17C10.25 13.2721 13.2721 10.25 17 10.25C20.7279 10.25 23.75 13.2721 23.75 17Z",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E64E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.25V17L19.25 18.5",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E64E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueIcon);
export default __webpack_public_path__ + "static/media/overdue-icon.63973db414ed8873d33b5a0974eaf66b.svg";
export { ForwardRef as ReactComponent };